import { useEffect, useState } from "react"
import Notify from "../Usenotifications"
import avatar from "../../images/avatar.png"
import { storage } from "../../../Firebase/config"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import { collection, addDoc, Timestamp } from "firebase/firestore"
import { db } from "../../../Firebase/config"

export const CreatecategoryHook = () => {
  const [Catname, setName] = useState("")
  const [loading, setLoading] = useState()
  const [isPress, setPress] = useState(false)

  const inputName = (e) => {
    setName(e.target.value)
  }

  const handlesubmit = async (e) => {
    e.preventDefault()

    if (Catname !== "") {
      try {
        const docRef = await addDoc(collection(db, "Categories"), {
          name: Catname,
          createdAt: Timestamp.now().toDate(),
        })
        Notify("Category Created succesfully", "success")
        setTimeout(() => {
          window.location.reload(false)
        }, 1000)
      } catch (err) {
        Notify("unable to Add Category", "error")
      }

      setName("")
    } else {
      Notify("Please Fill all necessary details", "error")
    }
  }

  return [Catname, isPress, loading, handlesubmit, inputName]
}
export default CreatecategoryHook
